import Image from 'next/image';
import { ClueCard } from '@snapi/luxury';
import SmilingBacteria from '../../landing/cover/images/smiling-bacteria.png';
import MonitorSectionImage from './images/monitor.png';
import { Button } from '@snapi/luxury';
import Link from 'next/link';

export function MonitorSectionScience() {
  return (
    <section id="monitor-section-science">
      <div className="container relative md:flex md:flex-col">
        <div className="absolute top-[-60px] right-[22px] w-9 sm:w-[58px] sm:right-[62px] sm:left-[540px] lg:top-[-80px] lg:left-[520px]">
          <Image src={SmilingBacteria} alt="" />
        </div>
        <div className="lg:flex justify-center">
          <div className="max-w-[510px] order-2">
            <Image src={MonitorSectionImage} alt="" />
          </div>
          <div className="order-1 relative lg:w-[506px] lg:mr-[54px] xl:mr-[200px]">
            <h2
              className="relative w-[202px] sm:w-[336px] 
                          text-start mb-3 md:w-[384px]"
            >
              Why monitor regularly?
              <div
                className="absolute text-center w-[200px] font-mono text-body 
                              font-normal sm:w-[226px] bottom-[2px] right-[-64px] text-[24px] 
                              sm:right-[-134px]"
              >
                <ClueCard
                  description="Childhood Prebiotic And Probiotic Review- Arkansas Children Research"
                  href="https://doi.org/10.4137/CMPed.S38338"
                  orientation="bottom"
                />
              </div>
            </h2>
            <p className="mb-10 xl:w-[580px] text-body">
              Monitoring gives us the power to help our baby’s gut reach its 
              full potential. Keeping your little one’s gut health in check 
              gives them every opportunity to thrive, as it can reduce the 
              risk of certain health conditions. A recent research study on 
              infant gut microbiome demonstrated that infants experienced an 
              increased risk of colic, diaper rash, eczema, allergies, and 
              Type 1 Diabetes when specific disruptive bacteria were unaddressed.
            </p>
            <div className="hidden lg:block">
              <Link href="#buy">
                <Button size="md">Buy now</Button>
              </Link>
            </div>
          </div>
        </div>
        <div className="lg:hidden">
          <Link href="#buy">
            <Button size="md">Buy now</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
